import { atom } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

export const webSocketState = atom<WebSocket | null>({
  key: `language/${uuidv4()}`,
  default: null,
});
